export default {

  highlightValue(result,key) {
    let highlightedArray = result.highlight[`${key}.analyzed`];
    if (typeof(highlightedArray) != 'undefined'){
      return highlightedArray[0];
    } else {
      return result[key];
    }
  },
  highlightDescription(result) {
    let highlightedArray = result.highlight['description.analyzed'];
    if (typeof(highlightedArray) != 'undefined'){
      return `...${highlightedArray[0]}...`;
    } else {
      return s.prune(result.description,200);
    }
  },
  highlightInstructors(result) { 
    let strInstructors = '';
    // make an array of all highlighted instructors
    let highlightedArray = result.highlight['instructors.analyzed'];
    // if current search term matches instructors for this result
    if (typeof(highlightedArray) != 'undefined') {
      // loop through instructors
      _.each(result.instructors, (instructor, instructorIndex) => {
        // for each entry in highlightedArray, strip the html and compare to the current entry in result.instructors
        _.each(highlightedArray, (highlight, highlightIndex) => {
          let strippedHighlight = highlight.replace('<span class=\'highlighted\'>', '');
          strippedHighlight = strippedHighlight.replace('</span>', '');
          // if the highlighted instructor matches the current entry in result.instructors, put in the highlighted instructor markup
          if(strippedHighlight == instructor){
            strInstructors += highlight;
          } else {
            // otherwise just add the instructor to the output string
            strInstructors += instructor;
          }
        });
        // add a comma between results
        if (instructorIndex < (result.instructors.length - 1)){
          strInstructors += ', ';
        }
      });
    } else {
      // if there NOT any highlighted instructors
      _.each(result.instructors, (instructor, index) => {
        // make a string of all instructors
        strInstructors += instructor;
        // add a comma between results
        if (index < (result.instructors.length - 1)){
          strInstructors += ', ';
        }
      });
    }
    // send the final string of instructors back to the markup
    return strInstructors;
  },
  searchResultOnClick(result, strQuery) {
    Kadenze.Analytics.track(
      'search',
      'result_clicked', {
        result: result,
        query: strQuery
      });
  }

};
